<template>
  <div>
    <AudioWithAliNLS />
  </div>
</template>
<script>
import AudioWithAliNLS from "../../components/audioWithAliNLS/AudioWithAliNLS.vue";

export default {
  name: "login",
  data: {},
  components: {
    AudioWithAliNLS,
  },
  created() {
    // this.$store.dispatch("common/loginAction").then((res) => {
    //   if (res.code == 0) {
    //     this.$store.dispatch("common/fetchUserInfoAction").then((res) => {
    //       if (res.code == 0) {
    //         router.push("/gsyy");
    //       }
    //     });
    //   }
    // });
    // return {};
  },
};
</script>
